import fetch from '@/utils/fetch';

// 获取订单列表
export function getOrderList(data) {
  return fetch({
    url: '/saas/order/m/s/list',
    method: 'post',
    data: data,
  });
}

// 获取订单详情
export function getOrderDetail(data) {
  return fetch({
    url: '/saas/order/m/s/get',
    method: 'post',
    data: data,
  });
}

// 退款
export function refundOrder(data) {
  return fetch({
    url: '/saas/order/m/s/refundV2',
    method: 'post',
    data: data,
  });
}

// 关闭订单
export function closeOrder(data) {
  return fetch({
    url: '/saas/order/m/s/close',
    method: 'post',
    data: data,
  });
}

// 发货
export function shipmentOrder(data) {
  return fetch({
    url: '/saas/order/m/s/shipment',
    method: 'post',
    data: data,
  });
}

// 获取某件商品订单列表
export function getGoodOrderList(data) {
  return fetch({
    url: '/saas/order/m/s/shop/order/search',
    method: 'post',
    data: data,
  });
}
/***
 * 修改订单
 */
export function correctOrder(data) {
  return fetch({
    url: '/saas/order/m/s/order/correct',
    method: 'post',
    data: data,
  });
}
/***
 * 增加地址
 */

export function correctAddress(data) {
  return fetch({
    url: '/saas/order/m/s/order/address/add',
    method: 'post',
    data: data,
  });
}

/***
 *  订单的 ticket  的列表
 */

export function getOrderTicketList(data) {
  return fetch({
    url: '/saas/order/m/s/shop/order/ticket/list',
    method: 'post',
    data: data,
  });
}
